import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';
import { Hr, Icon, sectionListStyles } from 'LocalGluons';
import { t } from 'Locale';

import { getIconByDeviceType } from 'Utils/';
import deviceListItemStyles from './DeviceListItem.jss';

const DeviceListItem = ({
    name,
    description,
    onPress,
    deviceType,
    testID,
    deviceId,
    sectionContainer
}) => (
    <View>
        <View style={[deviceListItemStyles.innerItemContainer, sectionContainer]}>
            <View style={deviceListItemStyles.iconTextContainer}>
                <Icon
                    style={deviceListItemStyles.icon}
                    name={getIconByDeviceType(deviceType)}
                    testID={`icon_${testID}`}
                />
                <Text
                    style={[
                        sectionListStyles.itemName,
                        deviceListItemStyles.itemName,
                        description ? deviceListItemStyles.itemNameWithDescription : {}
                    ]}
                    numberOfLines={1}
                >
                    {name}
                </Text>
                {deviceId && (
                    <Text
                        style={[
                            sectionListStyles.header,
                            deviceListItemStyles.itemDescription,
                            description ? { paddingTop: 12 } : { paddingTop: 10 }
                        ]}
                        numberOfLines={1}
                    >
                        {`(${t('COMMON.ID')}:${deviceId})`}
                    </Text>
                )}
            </View>
            {onPress && (
                <Icon
                    style={deviceListItemStyles.iconDelete}
                    name="delete"
                    onPress={onPress}
                    testID={`delete_${testID}`}
                />
            )}
        </View>
        {description.length > 0 ? (
            <Text style={[sectionListStyles.header, deviceListItemStyles.itemDescription]}>
                {description}
            </Text>
        ) : null}
        <Hr />
    </View>
);

DeviceListItem.defaultProps = {
    onPress: null,
    description: '',
    testID: undefined,
    deviceType: 'OTHER',
    deviceId: null
};

DeviceListItem.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    onPress: PropTypes.func,
    testID: PropTypes.string,
    deviceType: PropTypes.oneOf(['STB', 'SMART_TV', 'MOBILE_TABLET', 'WEB_BROWSER', 'OTHER']),
    deviceId: PropTypes.number
};

export { DeviceListItem, deviceListItemStyles };
